export const getSurvey = (userId) => {
  return ["survey", userId];
};
